<template>
  <div>
    <!-- 启动器设置 -->
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{ $t('messageAdd.launcher.001') }}</span>
      </el-col>
      <el-col :span="24">
        <span class="secondfont-title">{{ $t('messageAdd.launcher.002') }}</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle"
          >{{ $t("message.appDesktopMsg.desktopInfo") }}:</span
        >
        <el-button type="text" @click="openDesktopTypeDialog">
          {{ $t("message.appDesktopMsg.add") }}</el-button
        >
      </el-col>
      <el-col :span="24">
        <div class="tags-box" v-if="dData.length > 0">
          <el-tag id="tag-box" v-for="(v, i) in dData" :key="i">{{
            v.packageName.length > 30
            ? v.packageName.substring(0, 29) + "..."
            : v.packageName
          }}</el-tag>
        </div>
      </el-col>
      <!-- 暂时搁置 -->
      <!-- <el-col :span="24">
        <span class="secondfont-title">Stage Now桌面</span>
      </el-col>
      <el-col :span="10" class="setting-box">
        <span class="setTitle">Stage Now桌面开关:</span>
        <el-select size="medium" v-model="ls.s">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            value="false"
          ></el-option>
        </el-select>
      </el-col> -->
    </el-row>

    <!-- 自定义桌面类型 -->
    <el-dialog
      :title="$t('message.appDesktopMsg.desktopType')"
      :visible.sync="DesktopTypeDialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @close="handleCloseLauncher"
      width="50%"
    >
      <div style="width: 100%">
        <el-button
          type="text"
          icon="el-icon-circle-plus-outline"
          @click="addDesktopType"
          >{{ $t("message.appDesktopMsg.add") }}</el-button
        >
      </div>
      <el-table border :data="dData">
        <el-table-column
          prop="id"
          :label="$t('message.appDesktopMsg.index')"
          width="80"
          type="index"
          align="center"
        />
        <el-table-column
          prop="packageName"
          align="center"
          :label="$t('message.appDesktopMsg.PackageName')"
        >
          <template #default="scope">
            <span v-show="!scope.row.isEdit">{{ scope.row.packageName }}</span>
            <el-select
              v-model="scope.row.packageName"
              v-show="scope.row.isEdit"
              allow-create
              :multiple-limit="1"
              filterable
              :placeholder="$t('message.messageMsg.selectOrInput')"
            >
              <el-option
                value="com.android.launcher3"
                label="Quickstep"
              ></el-option>
              <el-option
                value="com.seuic.homedemo"
                label="Mobile Butler"
              ></el-option>
              <el-option
                value="com.seuic.mobiledevicemanager"
                label="Mobile Device Manager"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('message.appDesktopMsg.operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-circle-check"
              v-show="scope.row.isEdit"
              @click="okDesktopType(scope.row)"
              >{{ $t("common.save") }}
            </el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="editDesktopType(scope.row)"
              v-show="!scope.row.isEdit"
            >{{ $t('common.edit') }}</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="delDesktopType(scope.row)"
              v-show="!scope.row.isEdit"
            >{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseLauncher">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="saveDesktopType">{{ $t("common.submit") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props:{
    launchers:{
      type:Object
    }
  },
  data() {
    return {
      dData: [],
      DesktopTypeDialogVisible: false,
      // showDdata:[],
    };
  },
  computed:{
    launcher(){
      return this.launchers
    }
  },
  watch:{
  // 监听 launcher prop 的变化
  launcher: {
      handler(newVal, oldVal) {
        // 当 newVal.l 存在且不为空字符串时，更新 dData
        if (newVal.l && newVal.l !== '') {
          this.dData = [
            {
              packageName: newVal.l,
              isEdit: false
            }
          ];
          // this.showDdata=[{
          //   packageName: newVal.l
          // }];
        } else {
          this.dData = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    // 自定义桌面
    openDesktopTypeDialog() {
      this.DesktopTypeDialogVisible = true;
    },
    addDesktopType() {
      if (this.dData.length < 1) {
        this.dData.push({
          packageName: "",
          isEdit: true,
        });
      } else {
        this.$message.closeAll();
        this.$message({
          message: this.$t("message.messageMsg.desktopMsg"),
          type: "warning",
        });
      }
    },
    editDesktopType(data) {
      data.isEdit = true;
    },
    okDesktopType(data) {
      if (data.packageName != "") {
        data.isEdit = false;
      } else {
        this.$message({
          message: this.$t("message.messageMsg.pnNoEmpty"),
          type: "warning",
        });
      }
    },
    delDesktopType(data) {
      let i = this.dData.indexOf(data);
      this.dData.splice(i, 1);
    },
    saveDesktopType() {
        if (this.dData.length === 0) {
        // 当dData为空时，‌允许保存，‌并且不显示任何警告信息
          this.DesktopTypeDialogVisible = false;
        } else {
          if (this.dData[0].packageName === '') {
            // 当dData不为空，‌但packageName为空时，‌显示警告信息
            this.$message.warning(this.$t('messageAdd.launcher.003'));
          } else if (this.dData[0].isEdit) {
            // 当packageName不为空，‌但isEdit为true时，‌显示警告信息
            this.$message.warning(this.$t('messageAdd.launcher.004'));
          } else {
            // 当packageName不为空，‌且isEdit不为true时，‌执行保存逻辑
            const packageName = this.dData[0].packageName;
            const newData = { l: packageName, id: 3 };
            this.$emit('update:launcher', newData);
            this.$emit('update:config-launcher', newData);
            this.DesktopTypeDialogVisible = false;
          }
      }
    },
    handleCloseLauncher(){
      const res=JSON.parse(localStorage.getItem('launcher'));
      if(res){
        if(res.l&&res.l!=''){
          this.dData = [
              {
                packageName: res.l,
                isEdit: false
              }
            ];
        }else{
          this.dData=[];
        }
      }
      this.DesktopTypeDialogVisible=false;
    }
  },
  created(){

  }
};
</script>
